import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Landmark, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Loader, fmt, fmtDateTime, StatusBadge, EmptyState } from "@/components/shared";
import { Reveal } from "@/components/ShareVisuals";

export default function MyShareDeposits() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/shares/me").then((r) => setData(r.data)).catch(() => setData(false)); }, []);
  if (data === null) return <Loader label="Loading share deposits..." />;
  const deposits = data?.deposits || [];

  return (
    <div className="space-y-6" data-testid="my-share-deposits-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <p className="label-eyebrow text-xs font-mono uppercase tracking-[0.2em] text-cyan-400">Verification</p>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white mt-1">My Share Deposits</h1>
          <p className="text-sm text-slate-400 mt-2">Deposits submitted specifically for purchasing company shares and their verification status.</p>
        </div>
        <Link to="/shares-portal" data-testid="share-deposits-new-btn" className="btn-glow px-5 py-2.5 rounded-full text-sm font-semibold text-slate-950 inline-flex items-center gap-2 shrink-0">Deposit for Shares <ArrowRight className="w-4 h-4" /></Link>
      </div>

      <Reveal className="glass rounded-2xl p-6">
        {deposits.length ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm min-w-[820px]">
              <thead><tr className="text-left text-slate-500 border-b border-white/5">
                {["Reference", "Amount (USDT)", "Network", "Transaction ID", "Shares", "Date", "Status", "Admin Note"].map((x) => <th key={x} className="pb-3 font-medium">{x}</th>)}
              </tr></thead>
              <tbody>
                {deposits.map((d) => (
                  <tr key={d.id} className="border-b border-white/5 last:border-0" data-testid={`share-deposit-row-${d.id}`}>
                    <td className="py-3"><Link to={`/share-confirmation/deposit/${d.id}`} className="font-mono text-xs text-cyan-400 hover:underline">{d.id.slice(0, 8)}</Link></td>
                    <td className="py-3 font-mono text-white">{fmt(d.amount)}</td>
                    <td className="py-3 text-slate-300">{d.network}</td>
                    <td className="py-3 font-mono text-xs text-slate-500 max-w-[140px] truncate">{d.transaction_hash}</td>
                    <td className="py-3 font-mono text-slate-200">{d.issued_shares ?? d.intended_shares}{d.issued_shares == null && <span className="text-[10px] text-slate-500 ml-1">intended</span>}</td>
                    <td className="py-3 text-slate-500">{fmtDateTime(d.created_at)}</td>
                    <td className="py-3"><StatusBadge status={d.status} />{d.status === "pending" && <p className="text-[10px] text-amber-300/80 mt-1">Pending Verification</p>}</td>
                    <td className="py-3 text-xs text-slate-400 max-w-[180px]">{d.admin_note || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={Landmark} title="No share deposits yet" subtitle="Use Deposit for Shares to fund a share purchase directly." />}
      </Reveal>
    </div>
  );
}
